import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

import SetWeekDialog from '../components/SetWeekDialog'
import moment from 'moment'

class CampaignModal extends React.Component {
  state = {
    campaign: null,
    dialogOpen: false,
  }

  openDialog = () => {
    this.setState({ dialogOpen: true })
  }

  closeDialog = () => {
    this.setState({ dialogOpen: false })
  }

  onSetYear = weekNumber => {
    this.closeDialog()
    this.props.onSetWeek(weekNumber)
  }

  render() {
    const { props } = this
    const campaingsOptions = () => {
      const now = moment()
      const years = []
      for (let i = now.get('year'); i >= 2017; i--) {
        years.push(
          <MenuItem key={'yr' + i} onClick={() => props.onSetCampaignYear(i)}>
            {i}
          </MenuItem>,
        )
      }
      return years
    }
    return (
      <React.Fragment>
        {props.open && (
          <Dialog open={!this.state.dialogOpen} onClose={props.onClose}>
            <DialogTitle id="confirmation-dialog-title">Campaña</DialogTitle>
            <DialogContent>
              <MenuList style={{ marginTop: -10, marginBottom: 10 }}>{campaingsOptions()}</MenuList>
            </DialogContent>
            <DialogActions>
              {props.onClear && <Button onClick={props.onClear}>Borrar</Button>}
              <Button onClick={props.onClose} color="primary">
                Filtrar
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.weekDialogOpen && (
          <SetWeekDialog
            onOk={this.onSetYear}
            onCancel={this.closeDialog}
            getCurrentWeek={props.getCurrentWeek}
            getStartOfWeek={props.getStartOfWeek}
            getEndOfWeek={props.getEndOfWeek}
          />
        )}
      </React.Fragment>
    )
  }
}

const styles = {
  datePicker: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial' !important",
  },
}

export default withStyles(styles)(CampaignModal)



// WEBPACK FOOTER //
// ./src/components/CampaignModal.js